import React, { useEffect, useState } from "react";
import { Button, Modal } from "antd";
import { MODAL_STYLES, MODAL_TITLE_STYLE } from "../../../styles/modalStyles";
import { offSessionExpired, onSessionExpired } from "../../../utils/sessionEvents";
import { resetSessionState } from "../../utils/SessionReset";

const AUTO_REDIRECT_SECONDS = 10;

const endSessionAndRedirect = (): void => {
  localStorage.clear();
  sessionStorage.clear();
  resetSessionState();
  window.location.replace("/login");
};

export const SessionExpiredModal: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleSessionExpired = () => setVisible(true);
    onSessionExpired(handleSessionExpired);
    return () => offSessionExpired(handleSessionExpired);
  }, []);

  useEffect(() => {
    if (!visible) return;

    const timer = setTimeout(endSessionAndRedirect, AUTO_REDIRECT_SECONDS * 1000);
    return () => clearTimeout(timer);
  }, [visible]);

  return (
    <Modal
      open={visible}
      closable={false}
      maskClosable={false}
      keyboard={false}
      title={<span style={MODAL_TITLE_STYLE}>Session Expired</span>}
      styles={MODAL_STYLES}
      footer={[
        <Button key="login" type="primary" onClick={endSessionAndRedirect}>
          Log In
        </Button>,
      ]}
    >
      <span style={{ color: "rgba(255,255,255,0.85)" }}>
        Your session has timed out. Please log in again to continue.
      </span>
    </Modal>
  );
};
